<ng-container *ngIf="companyDetail">
  <div class="company-card shadow-sm overflow-hidden">

    <!-- Top Section -->
    <div class="text-center p-4"
      style="background:transparent; color:var(--bs-primary); border:1px solid var(--bs-primary);">

      <div class="rounded-circle d-inline-flex align-items-center justify-content-center"
        style="width:70px; height:70px; background:white; border:4px solid #E5E5E5;">
        <i class="bi bi-building fs-2 text-primary"></i>
      </div>

      <h5 class="mt-3 mb-0">
        <ng-container *ngIf="!editingField; else editName">
          {{ companyDetail.cName }}
          <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 18px;"
            (click)="copyData(companyDetail.cName)">
          </i>

        </ng-container>
        <ng-template #editName>
          <input class="form-control text-center" [(ngModel)]="companyDetail.cName">
        </ng-template>
      </h5>
    </div>

    <div class="p-2 pt-3 pb-2">

      <!-- Contact Person -->
      <div class="d-flex align-items-center mb-1">
        <div class="icon-bg me-2">
          <i class="bi bi-person-circle fs-5 text-primary"></i>
        </div>

        <span class="flex-grow-1 d-flex align-items-center">
          <ng-container *ngIf="!editingField; else editPerson">
            {{ companyDetail.contactPerson }}
            <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
              (click)="copyData(companyDetail.contactPerson)">
            </i>


          </ng-container>

          <ng-template #editPerson>
            <input class="form-control form-control-sm" [(ngModel)]="companyDetail.contactPerson">
          </ng-template>
        </span>
      </div>

      <form #companyForm="ngForm">
        <!-- Email -->
        <div class="d-flex align-items-center mb-1">
          <div class="icon-bg me-2">
            <i class="bi bi-envelope fs-5 text-primary"></i>
          </div>

          <span class="flex-grow-1 d-flex align-items-center">
            <ng-container *ngIf="!editingField; else editEmail">
              {{ companyDetail.email }}
              <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
                (click)="copyData(companyDetail.email)">
              </i>

            </ng-container>

            <ng-template #editEmail>
              <div class="w-100">
                <input class="form-control form-control-sm" type="email" name="email" required
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #emailRef="ngModel"
                  [(ngModel)]="companyDetail.email" [class.is-invalid]="emailRef.invalid && companyDetail.email">

                <small class="text-danger" *ngIf="emailRef.invalid && companyDetail.email">
                  Enter valid Email
                </small>
              </div>
            </ng-template>



          </span>
        </div>

        <!-- Phone -->
        <div class="d-flex align-items-center mb-1">
          <div class="icon-bg me-2">
            <i class="bi bi-telephone fs-5 text-primary"></i>
          </div>

          <span class="flex-grow-1 d-flex align-items-center">
            <ng-container *ngIf="!editingField; else editPhone">
              {{ companyDetail.phone }}
              <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
                (click)="copyData(companyDetail.phone)">
              </i>
            </ng-container>

            <ng-template #editPhone>
              <div class="w-100 d-flex flex-column">
                <input class="form-control form-control-sm" type="tel" name="phone" required pattern="^[0-9]{10}$"
                  #phoneRef="ngModel" [(ngModel)]="companyDetail.phone"
                  [class.is-invalid]="phoneRef.invalid && companyDetail.phone">

                <small class="text-danger mt-1" *ngIf="phoneRef.invalid && companyDetail.phone">
                  Enter valid Phone
                </small>
              </div>
            </ng-template>


          </span>
        </div>
      </form>


      <!-- Address -->
      <div class="d-flex align-items-center mb-1">
        <div class="icon-bg me-2">
          <i class="bi bi-geo-alt fs-5 text-primary"></i>
        </div>

        <span class="flex-grow-1 d-flex align-items-center">
          <ng-container *ngIf="!editingField; else editAddress">
            {{ companyDetail.cAddress }}

            <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
              (click)="copyData(companyDetail.cAddress)">
            </i>
          </ng-container>

          <ng-template #editAddress>
            <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="companyDetail.cAddress"></textarea>
          </ng-template>
        </span>
      </div>



      <!-- Tags -->
      <div class="mt-3">
        <ng-container *ngIf="!editingField; else editTags">
          <span class="d-flex align-items-center gap-1 ">
            <i class="bi bi-link-45deg" style="color:#797979;"></i>
            {{ companyDetail.category }}
          </span>

          <span class="d-flex align-items-center gap-1 ">
            <i class="bi bi-link-45deg" style="color:#797979;"></i>

            {{ companyDetail.subCategory }}
          </span>
        </ng-container>

        <ng-template #editTags>
          <input class="form-control mb-1" placeholder="Category" [(ngModel)]="companyDetail.category">

          <input class="form-control" placeholder="Sub Category" [(ngModel)]="companyDetail.subCategory">
        </ng-template>
      </div>

      <!-- Buttons -->
      <div class="edit-buttons mt-3 d-flex justify-content-end gap-2">

        <!-- Edit -->
        <div class="edit-btn text" *ngIf="!editingField" (click)="editField()">
          <i class="bi bi-pencil-fill" style="color: #d9d9d9;"></i>
        </div>

        <!-- Save & Cancel -->
        <ng-container *ngIf="editingField">
          <div class="edit-btn" (click)="saveField(companyForm)">
            <i class="bi bi-check-lg"></i>
          </div>


          <div class="edit-btn" (click)="cancelEdit()">
            <i class="bi bi-x-lg"></i>
          </div>
        </ng-container>

      </div>

    </div>
  </div>
</ng-container>
